module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/sash-window/window.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/sash-window/window.png
// module id = 486
// module chunks = 0